/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 4/8/2015
 * Time: 3:48 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    //require regions fold
    var LE = require("app");
    var BaseDataManager = require("controllers/BaseDataManager");

    //collections
    var UsersCollection = require("collections/entities/UsersCollection");
    var SkillsCollection = require("collections/entities/SkillsCollection");
    var SurveyCollection = require("collections/entities/SurveyCollection");
    var PermissionGroupsCollection = require("user-management-collections/PermissionGroupsCollection");
    var AgentGroupsCollection = require("user-management-collections/AgentGroupsCollection");
    var ProfilesCollection = require("collections/entities/ProfilesCollection");
    var DefaultProfilesCollection = require("user-management-collections/DefaultProfilesCollection");
    var SettingsCollection = require("collections/SettingsCollection");
    var ProfileModel = require("models/entities/ProfileModel");
    var NumOfSeatsModel = require("user-management-models/NumberOfSeatsModel");
    var SiteSettingsModel = require("models/SiteSettingsModel");

    var ENTITY_ENUM = {
        USER: UsersCollection.NAME,
        SKILL: SkillsCollection.NAME,
        SURVEY: SurveyCollection.NAME,
        AGENT_GROUP: AgentGroupsCollection.NAME,
        PERMISSION_GROUP: PermissionGroupsCollection.NAME,
        LOB: "", // will be set dynamically on init (we get the collection from data-module and use its name)
        LOB_RELATIONS: "", // will be set dynamically on init (we get the collection from data-module and use its name)
        API_KEYS: "", // will be set dynamically on init (we get the collection from data-module and use its name)
        PROFILES: ProfilesCollection.NAME,
        PROFILES_FULL_DATA: ProfilesCollection.NAME + "FullData",
        DEFAULT_PROFILES: "DefaultProfilesCollection",
        AGENT_MANAGER_MODEL: "", // will be set dynamically on init (we get the collection from data-module and use its name)
        SITE_SETTINGS_USER_LIST: "SiteSettingsUserList",
        NUM_OF_SEATS: NumOfSeatsModel.NAME,
        SITE_SETTINGS_WRAP_UP_TIME: "SiteSettingsWrapUpTime",
        SITE_SETTINGS_SLA: "SiteSettingsSLA",
        SITE_SETTINGS_AUTO_CLOSE: "SiteSettingsAutoClose",
        SITE_SETTINGS_TRANSFER_TO_AGENT: "SiteSettingsTransferToAgent",
        LOGGED_IN_USER: "LoggedInUserModel",
        SPECIAL_OCCASIONS: "",
        SCHEDULES: "",
        SITE_SETTINGS_MANUAL_SHIFT_STATUS: "SiteSettingsManualShiftStatusModel"
    };

    var UsersDataManager = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UsersDataManager = BaseDataManager.extend({
            initialize: function(options) {
                LEUserManagement.logger.info("initializing", "UsersDataManager:initialize");
                this._initData(options);
                this._bindEvents();
            },

            getEntities: function() {
                return this._getEntities();
            },

            getProfilesRolesGroupOrder: function(){
                return this._getProfilesRolesGroupOrder();
            },

            _initData: function(options) {
                BaseDataManager.prototype.initialize.call(this, options);

                this.addDataObj(ENTITY_ENUM.USER, new UsersCollection());
                this.addDataObj(ENTITY_ENUM.SKILL, new SkillsCollection());
                this.addDataObj(ENTITY_ENUM.SURVEY, new SurveyCollection());
                this.addDataObj(ENTITY_ENUM.PERMISSION_GROUP, new PermissionGroupsCollection());
                this.addDataObj(ENTITY_ENUM.AGENT_GROUP, new AgentGroupsCollection());
                this.addDataObj(ENTITY_ENUM.PROFILES, new ProfilesCollection());
                this.addDataObj(ENTITY_ENUM.PROFILES_FULL_DATA, new ProfilesCollection([], {urlSelectParameter:ProfilesCollection.URL_SELECT_PARAMETER.ALL}));
                this.addDataObj(ENTITY_ENUM.DEFAULT_PROFILES, new DefaultProfilesCollection());
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_USER_LIST, new SettingsCollection([], {groups:SettingsCollection.SETTINGS_ENUM.SETTING_GROUP.userListSettings, contextType: SettingsCollection.SETTINGS_ENUM.CONTEXT_TYPE.ACCOUNT, contextCascading: true}));
                this.addDataObj(ENTITY_ENUM.NUM_OF_SEATS, new NumOfSeatsModel());
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_TRANSFER_TO_AGENT, new SiteSettingsModel({ id: SettingsCollection.SETTINGS_ENUM.SETTING_ID.MESSAGING_ACD_TRANSFER_MAX_WAIT_IN_QUEUE_TIME }));
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_SLA, new SettingsCollection([], {groups:SettingsCollection.SETTINGS_ENUM.SETTING_GROUP.nvSLASettings , contextType: SettingsCollection.SETTINGS_ENUM.CONTEXT_TYPE.ACCOUNT, contextCascading: true}));
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_WRAP_UP_TIME, new SettingsCollection([], {groups:SettingsCollection.SETTINGS_ENUM.SETTING_GROUP.wrapUpTime, contextType: SettingsCollection.SETTINGS_ENUM.CONTEXT_TYPE.ACCOUNT, contextCascading: true}));
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_AUTO_CLOSE, new SiteSettingsModel({ id: SettingsCollection.SETTINGS_ENUM.SETTING_ID.MESSAGING_AUTO_CLOSE }));

                var lobCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLobsCollection);
                ENTITY_ENUM.LOB = lobCollection.name;
                this.addDataObj(ENTITY_ENUM.LOB, lobCollection);

                var lobRelationsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLobRelationsCollection);
                ENTITY_ENUM.LOB_RELATIONS = lobRelationsCollection.name;
                this.addDataObj(ENTITY_ENUM.LOB_RELATIONS, lobRelationsCollection);

                var agentManagerModel = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAgentManagerModel);
                ENTITY_ENUM.AGENT_MANAGER_MODEL = agentManagerModel.name;
                this.addDataObj(ENTITY_ENUM.AGENT_MANAGER_MODEL, agentManagerModel);

                var apiKeysCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getApiKeysCollection);
                ENTITY_ENUM.API_KEYS = apiKeysCollection.name;
                this.addDataObj(ENTITY_ENUM.API_KEYS, apiKeysCollection);

                var schedulesCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getSchedulesCollection);
                ENTITY_ENUM.SCHEDULES = schedulesCollection.name;
                this.addDataObj(ENTITY_ENUM.SCHEDULES, schedulesCollection, {isMandatory:true});

                var specialOccasionsCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getSpecialOccasionsCollection);
                ENTITY_ENUM.SPECIAL_OCCASIONS = specialOccasionsCollection.name;
                this.addDataObj(ENTITY_ENUM.SPECIAL_OCCASIONS, specialOccasionsCollection, {isMandatory:true});

                var siteSettingsManualShiftStatusModel = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getSiteSettingsManualShiftStatusModel);
                this.addDataObj(ENTITY_ENUM.SITE_SETTINGS_MANUAL_SHIFT_STATUS, siteSettingsManualShiftStatusModel, {isMandatory:true});

                var loggedInUserModel = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLoggedInUserModel);
                this.addDataObj(ENTITY_ENUM.LOGGED_IN_USER, loggedInUserModel, {freshnessTime: Infinity});
            },

            _bindEvents: function() {

            },

            getLobSupportedTypes: function() {
                return this.getData(ENTITY_ENUM.LOB_RELATIONS).model.SUPPORTED_ENTITY_TYPES;
            },

            getPermissionGroupNameById: function(permissionGroupId) {
                var permissionGroupModel = this.getData(this._getEntities().PERMISSION_GROUP).get(permissionGroupId);
                if (permissionGroupModel) {
                    return permissionGroupModel.getTranslatedName();
                }
            },

            getArrayNamesByIds: function(entity, idsArray, nameAttribute) {
                var namesArray = [];
                var collection = this.getData(entity);
                var name = "";

                if (collection && idsArray) {
                    _.each(idsArray, function(id){
                        var model = collection.get(id);
                        if (!_.isEmpty(model)) {
                            var nameAttr = nameAttribute || "name";
                            name = model.get(nameAttr);
                            namesArray.push({"id": id, "name": name});
                        }
                    });
                }
                return namesArray;
            },

            _getEntities: function() {
                return ENTITY_ENUM;
            },

            _getProfilesRolesGroupOrder: function(){
                var RoleGroupOrder = [
                    ProfileModel.ROLES.AGENT,
                    ProfileModel.ROLES.AGENT_MANAGER,
                    ProfileModel.ROLES.CAMPAIGN_MANAGER,
                    ProfileModel.ROLES.ADMINISTRATOR
                ];

                var result =  _.map(RoleGroupOrder, function(roleType){
                    return LE.translator.translate(ProfileModel.ROLES_BY_IDS[roleType]);
                });

                return result;
            }
         });
    }

    LE.module("LEUserManagement", moduleDefinition);

    UsersDataManager.ENTITY_ENUM = ENTITY_ENUM;

    return UsersDataManager;

});
